import type { Routes } from '@angular/router';

export const APP_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () => import('./features/feed/feed.component').then(m => m.FeedComponent),
    data: { mainTab: 'whats-new' },
  },
  {
    path: 'coming-soon',
    loadComponent: () => import('./features/feed/feed.component').then(m => m.FeedComponent),
    data: { mainTab: 'coming-soon' },
  },
  {
    path: 'changelog',
    loadComponent: () => import('./features/feed/feed.component').then(m => m.FeedComponent),
    data: { mainTab: 'changelog' },
  },
  {
    path: 'timeline',
    loadComponent: () =>
      import('./features/timeline/timeline.component').then(m => m.TimelineComponent),
    data: { mainTab: 'timeline' },
  },
  {
    path: 'article/:slug',
    loadComponent: () =>
      import('./features/article-detail/article-detail.component').then(
        m => m.ArticleDetailComponent,
      ),
  },
  {
    path: '**',
    redirectTo: '',
  },
];
